import styled from "styled-components";
import React from 'react';
import { ContactInfo } from "./HeroElements";
import { color, font, layout } from "../../theme/tokens";

/** Full-bleed clay band that closes every page. */
export const EmailGrabContainer = styled.footer`
  display: flex;
  justify-content: center;
  background: ${color.clay};
  padding: 96px 0 72px;

  @media screen and (max-width: 800px) {
    padding: 64px 0 48px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 64px;
  max-width: ${layout.maxWidth};
  width: 100%;
  padding: 0 ${layout.gutter};

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 40px;
  }

  @media (max-width: 800px) {
    padding: 0 ${layout.gutterMobile};
  }
`;

export const EmailGrabText = styled.h2`
  font-family: ${font.display};
  color: ${color.white};
  font-size: 48px;
  font-weight: 400;
  letter-spacing: -0.015em;
  line-height: 1.15;
  margin: 0 0 28px 0;
  max-width: 14ch;

  @media (max-width: 900px) {
    font-size: 38px;
    max-width: none;
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;

const FooterLabel = styled.p`
  font-family: ${font.body};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
  margin: 0 0 20px;
`;

const FooterRight = styled.div`
  min-width: 260px;
`;

const Colophon = styled.div`
  display: flex;
  justify-content: center;
  background: ${color.clayDeep};
  padding: 22px 0;

  span {
    font-family: ${font.body};
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.8);
  }
`;

function EmailGrab() {
  return (
    <>
      <EmailGrabContainer>
        <InnerContainer>
          <div>
            <EmailGrabText>We partner early and stay long.</EmailGrabText>
          </div>
          <FooterRight>
            <FooterLabel>Get in touch</FooterLabel>
            <ContactInfo>
              <a href="mailto:inquiries@vitalforcecapital.com">inquiries@vitalforcecapital.com</a>
              <a href="https://x.com/vitalforcecap" target="_blank" rel="noopener noreferrer">X — @vitalforcecap</a>
              <a href="https://www.linkedin.com/company/vitalforce-capital" target="_blank" rel="noopener noreferrer">LinkedIn — vitalforce-capital</a>
            </ContactInfo>
          </FooterRight>
        </InnerContainer>
      </EmailGrabContainer>
      <Colophon>
        <span>© {new Date().getFullYear()} Vitalforce Capital</span>
      </Colophon>
    </>
  );
}

export default EmailGrab;
